<p-table #table
    [value]="timelines"
    responsiveLayout="stack"
    [breakpoint]="'960px'"
    styleClass="scheda-tabella p-datatable-sm"
    [paginator]="true"
    [showCurrentPageReport]="true"
    [rowHover]="true"
    [globalFilterFields]="['titolo']"
    currentPageReportTemplate="{first} di {last} su {totalRecords} timeline"
    [rows]="5" [rowsPerPageOptions]="[5, 10, 20, 50]">
    <ng-template pTemplate="caption">
        <div class="flex lg:flex-row flex-col gap-3 w-full">
            <div class="lg:w-3/4 w-full">
                <p-iconfield iconPosition="left" [style]="{'width': '100%'}">
                    <p-inputicon styleClass="bi bi-search" />
                    <input type="text" pInputText (input)="onGlobalFilter(table, $event)" placeholder="Cerca timeline…" [style]="{'width': '100%'}" />
                </p-iconfield>
            </div>
            <div class="lg:w-1/4 w-full table-toolbar-btns">
                <button class="flex-1 acc-btn" type="button" (click)="add = true">
                    <i class="bi bi-plus"></i>
                    Aggiungi timeline
                </button>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th class="w-1/12"></th>
            <th class="w-9/12">Titolo</th>
            <th class="w-2/12 text-center">Azioni</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-timeline let-index="rowIndex">
        <tr [pReorderableRow]="index">
            <td class="text-center">
                <i class="bi bi-list text-2xl hover:text-black cursor-grab" pReorderableRowHandle></i>
            </td>
            <td><span class="cell-nome">{{timeline.titolo || '-'}}</span></td>
            <td class="text-center">
                <div class="table-actions">
                    <a [href]="timeline.immagine ? (timeline.immagine + '?type=image' | file) : (timeline.pdf | pdf)" target="_blank">
                        <i class="bi" [ngClass]="{'bi-card-image': timeline.immagine, 'bi-file-pdf': timeline.pdf}"></i>
                    </a>
                    <p-divider layout="vertical"></p-divider>
                    <i class="bi bi-pencil" (click)="onOpenEdit(timeline)"></i>
                    <p-divider layout="vertical"></p-divider>
                    <ng-container *ngIf="timeline.id">
                        <p-confirmPopup #deleteTimeline>
                            <ng-template pTemplate="headless" let-message>
                                <div class="border-round p-3">
                                    <span class="text-base">{{ message.message }}</span>
                                    <div class="flex align-items-center gap-2 mt-3">
                                        <button type="button" class="acc-btn flex-1" (click)="onDelete()">Elimina</button>
                                        <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onAnnullaDelete()">Annulla</button>
                                    </div>
                                </div>
                            </ng-template>
                        </p-confirmPopup>
                        <i class="bi bi-trash" (click)="onOpenDelete($event, timeline, index)"></i>
                    </ng-container>
                    <ng-container *ngIf="!timeline.id">
                        <i class="bi bi-trash" (click)="timelines.splice(index, 1)"></i>
                    </ng-container>
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="3">Nessun dato presente nella timeline.</td>
        </tr>
    </ng-template>
</p-table>

<p-dialog [visible]="(add || edit)" [style]="{width: '75%'}" [header]="add ? 'Aggiungi timeline' : 'Modifica timeline'" [modal]="true" styleClass="accrediti-dialog" (visibleChange)="onCloseModal();">
    <ng-template pTemplate="content">
        <form [formGroup]="formTimeline" class="accrediti-form flex flex-col gap-6" (ngSubmit)="add ? onAdd() : onEdit()">
            <div class="flex lg:flex-row flex-col gap-4">
                <div class="fld flex-1">
                    <label>* Titolo</label>
                    <input type="text" pInputText class="w-full" formControlName="titolo" />
                </div>
                <div class="fld flex-1">
                    <label>* Data</label>
                    <p-calendar formControlName="data" dateFormat="dd/mm/yy" appendTo="body" [showIcon]="true" styleClass="w-full" />
                </div>
            </div>
            <div class="fld">
                <label>Descrizione</label>
                <p-editor [style]="{ height: '150px' }" formControlName="descrizione" />
            </div>
            @if (add) {
                <div class="flex lg:flex-row flex-col gap-4">
                    <div class="fld flex-1">
                        <label>Immagine</label>
                        <app-file-upload
                            [form]="formTimeline"
                            [control]="'immagine'"
                            [label]="''"
                            [multiple]="false"
                            [disable]="!show_pdf"
                            [accept]="'image/*'"
                            [text]="'Trascina qui l\'immagine'"
                            (load)="onImmagineUpload($event)">
                        </app-file-upload>
                    </div>
                    <div class="fld flex-1">
                        <label>PDF</label>
                        <app-file-upload
                            [form]="formTimeline"
                            [control]="'pdf'"
                            [label]="''"
                            [multiple]="false"
                            [disable]="!show_pdf"
                            [accept]="'application/pdf'"
                            [text]="'Trascina qui il PDF'"
                            (load)="onPDFUpload($event)">
                        </app-file-upload>
                    </div>
                </div>
            }
            <div class="acc-actions">
                <button type="button" class="acc-btn acc-btn-ghost" (click)="onCloseModal()">Annulla</button>
                <button type="submit" class="acc-btn acc-btn-primary" [disabled]="!formTimeline.valid">{{add ? 'Aggiungi' : 'Modifica'}}</button>
            </div>
        </form>
    </ng-template>
</p-dialog>
